import {WBIcon} from '@wandb/ui';
import React, {FC, memo} from 'react';

import {isInIframe} from '../../../setup';
import {useViewer} from '../../../state/viewer/hooks';
import {useIsAdminModeActiveAndIsNotLocalEnv} from '../../../util/admin';
import {useBetaFeatureWeave1} from '../../../util/useBetaFeature';
import AlertsManagementModal from '../../AlertsManagementModal';
import {InviteTeamButton} from '../../InviteTeamButton';
import {useNavContext} from '../../NavContextProvider';
import AdminModeWarning from './AdminModeWarning';
import NavResources from './NavResources';
import NavSearchButton from './NavSearchButton';
import ProfileMenu from './ProfileMenu';
import * as S from './SearchNav.styles';
import WeaveModeWarning from './WeaveModeWarning';

type NavRightProps = {
  isSignup: boolean;
};

const NavRightComp: FC<NavRightProps> = ({isSignup}) => {
  const {searchData: data} = useNavContext();
  const viewer = useViewer();
  const showAdminBanner = useIsAdminModeActiveAndIsNotLocalEnv();
  const showWeaveBanner = useBetaFeatureWeave1();

  return isInIframe() ? (
    <S.OpenPageLink
      href={document.location.href.replace('jupyter=true', '')} // TODO: actually parse the query and handle other flags?
    >
      Open page <WBIcon style={{marginLeft: 5}} name="right-arrow" />
    </S.OpenPageLink>
  ) : (
    <>
      {showAdminBanner && <AdminModeWarning />}
      {showWeaveBanner && <WeaveModeWarning />}
      {viewer != null && (
        <>
          <InviteTeamButton />
          {!isSignup && data != null && <NavSearchButton />}
          <AlertsManagementModal location="search nav" />
        </>
      )}
      <NavResources />
      <ProfileMenu isSignup={isSignup} />
    </>
  );
};

const NavRight = memo(NavRightComp);

export default NavRight;
